export { default } from './IndustriesChart';
